// Only reached when a server answers /privacidad with the SPA: shows the same static page.
export default function LegalPage({ page, title }) {
  return <iframe src={`/${page}.html`} title={title} className="fixed inset-0 h-full w-full border-0" data-testid={`legal-frame-${page}`} />;
}
